/**
 * Store admin — Product edit route (Commerce, V1.0.1 M2.1).
 */
import { createFileRoute } from "@tanstack/react-router";
import { ProductEditPage } from "../../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/products/$listingId/edit")({
  component: EditRoute,
});

function EditRoute() {
  const { listingId } = Route.useParams();
  return <ProductEditPage listingId={listingId} />;
}
